import React, { useState, useCallback } from 'react';
import s from './App.module.css';
import TriageForm from './components/TriageForm';
import VerdictPanel from './components/VerdictPanel';
import { decide, STYLE, leadWedge } from './triageLogic';

const INITIAL = {
  type: null,
  geo: null,
  hooks: [],
  volume: null,
  money: null,
  pain: null,
  buyer: null,
  effort: null,
};

export default function App() {
  const [form, setForm] = useState(INITIAL);
  const [copied, setCopied] = useState(false);

  const setField = useCallback((field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  }, []);

  const toggleHook = useCallback((value) => {
    setForm(prev => ({
      ...prev,
      hooks: prev.hooks.includes(value)
        ? prev.hooks.filter(h => h !== value)
        : [...prev.hooks, value],
    }));
  }, []);

  const verdict = decide(form);
  const st = STYLE[verdict.kind];
  const wedge = leadWedge(verdict.hooks, verdict.kind);

  const handleCopy = () => {
    const lines = [
      'FiniGenie lead triage',
      `Verdict: ${st.t}${verdict.motion ? (' — ' + verdict.motion) : ''}`,
      verdict.owner ? `Owner: ${verdict.owner.replace(/^Owner:\s*/, '')}` : null,
      `Lead with: ${wedge}`,
      `Fit score: ${verdict.score}/100`,
      `Why: ${verdict.reasons.join(' | ')}`,
    ].filter(Boolean);

    navigator.clipboard.writeText(lines.join('\n'))
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1400);
      })
      .catch(() => setCopied(false));
  };

  return (
    <div className={s.page}>
      <div className={s.wrap}>
        <header className={s.top}>
          <div className={s.kicker}>FiniGenie · Sales Operating System</div>
          <h1 className={s.h1}>Lead Triage</h1>
          <p className={s.sub}>
            Fill in what you know about a lead. The panel decides whether it earns your time — and if so, which wedge to lead with and who should own it. The rule of thumb it enforces: acquire the bottom of the pyramid through the product, spend human selling time only where money and access exist.
          </p>
        </header>

        <div className={s.grid}>
          <TriageForm
            form={form}
            setField={setField}
            toggleHook={toggleHook}
          />
          <VerdictPanel
            verdict={verdict}
            style={st}
            wedge={wedge}
            onCopy={handleCopy}
            copied={copied}
          />
        </div>

        <p className={s.foot}>
          How to read it: <strong>Self-serve</strong> means the lead is real but not worth human selling time — point them at the free product and let usage and data do the work, then upsell. <strong>Invest</strong> means the money and access justify a person; the motion tells you which one. <strong>Nurture</strong> means keep it warm but off the front of the queue. <strong>Drop</strong> means no fit today. The fit score is a confidence check, not the decision.
        </p>
      </div>
    </div>
  );
}
